module.exports = __webpack_public_path__ + "static/media/bg.19c31893.jpg";